import React, { Fragment } from "react";
import { Col, Row } from "react-bootstrap";
import { driverPay_source, driverPay_sourceSource_info } from '../DCR.dtos';
import { maskWespathAccountNumber, maskAccountNumber } from "../functions/dcrGlobal";

export interface DisplayBankInfoProps { pmtAccount: driverPay_source | undefined }
const DisplayBankInfo = (props: DisplayBankInfoProps) => {

    const getFieldValue = (accountField: driverPay_sourceSource_info) => {
        if (accountField.name === "Account Type:") {
            return (accountField.value.replace(/%20/g, ' ').trim().toLowerCase() === "checking" ? "Checking" : "Savings");
        }

        if (accountField.name === "Account Number:") {
            return maskAccountNumber(accountField.value?.replace(/%20/g, ' '));
        }

        if (accountField.name === "Wespath Account Number:") {
            return maskWespathAccountNumber(accountField.value?.replace(/%20/g, ' '));
        }

        if (accountField.name === "Phone Number:") {
            return accountField.value?.replace(/%20/g, ' ').replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        }

        return decodeURIComponent(accountField.value);
    }

    return (
        <>
            {
                props.pmtAccount?.source_info.map((accountField, i) =>
                    <Fragment key={i}>
                        {
                            (<Row className="ml-2">
                                <Col className="col-6 col-md-5 control-label">{accountField.name.replace(/%20/g, ' ')}</Col>
                                <Col className="col-6 col-md-7 control-value">{getFieldValue(accountField)}</Col>
                            </Row>)
                        }
                    </Fragment>
                )
            }
        </>
    )
}

export { DisplayBankInfo }